<template>
  <div>
    <div class="page-content border-bottom">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
          <el-form-item label="会员姓名">
            <el-input v-model="searchInfo.memRealName" placeholder="请输入会员姓名" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchInfo.memTel" placeholder="请输入会员手机号" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="searchInfo.carNo" placeholder="请输入会员手机号" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item label="积分类型">
          <el-select v-model="searchInfo.pointsType" placeholder="请选择积分类型" class="form-item-width">
            <el-option v-for="item in searchOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
            <el-button type="primary" @click="onAddUser">新增</el-button>
            <!-- <el-button type="danger" @click="onReview">审核</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格展示区域 -->
    <div class="page-content margin-top">
      <!-- 表格组件 -->
      <el-table :data="tableData" stripe style="width: 100%"  border
        :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
        :cell-style="{'text-align':'center'}" height="66vh" scroll-y
      >
        <!-- 循环展示表格 -->
        <!-- <el-table-column v-for="tab in tableTitle" :key="tab.code" :label="tab.name" show-overflow-tooltip
          :width="tab.width">
          <template slot-scope="scope">
            <span v-if="tab.formatter" :style="{ color: getColumnColor(scope.row[tab.code],tab.prop) }">{{ tab.formatter(scope.row[tab.code]) }}</span>
            <span v-else>{{ scope.row[tab.code] }}</span>
           </template>
          </el-table-column>  -->
        <el-table-column label="会员姓名" prop='memRealName'></el-table-column>
        <el-table-column label="手机号" prop='memTel' width="120px"></el-table-column>
        <el-table-column label="车牌号" prop='carNo'></el-table-column>
        <el-table-column label="积分类型" prop='pointsType'>
          <template slot-scope="scope">
            <span v-if="scope.row.pointsType === 1">充电</span>
            <span v-if="scope.row.pointsType === 2">评论</span>
            <span v-else-if="scope.row.pointsType === 5">核销</span>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" prop='chargeDegree'></el-table-column>
        <el-table-column label="积分数量" prop='pointsCount'></el-table-column>
        <el-table-column label="累计积分" prop='subPoints'></el-table-column>
        <el-table-column label="完成时间" prop='createTime' width="170px"></el-table-column>
        <el-table-column label="图片凭证" prop='pointsPicture'>
          <template v-if="scope.row.pointsType !=5 " slot-scope="scope">
            <img :src="baseURL + scope.row.pointsPicture" style="width: 50px; height: 50px;" @click="handleImageClick(baseURL + scope.row.pointsPicture)"/>
          </template>
          <template><span></span></template>
        </el-table-column>
        <el-table-column label="审核状态" prop='status'>
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: rgb(238, 145, 6)">待审核</span>
            <span v-else-if="scope.row.status === 1" style="color: #008000">已审核</span>
            <span v-else-if="scope.row.status === 2" style="color: red">已拒绝</span>
          </template>
        </el-table-column>
        
          <!-- 操作 -->
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">
              <el-popconfirm :title="`确定审批通过${scope.row.memRealName}的积分申请吗？`" @confirm="passApply(scope.row)"
                icon="el-icon-delete" icon-color="skyblue">
                <span slot="reference" class="pass-btn">通过</span>
              </el-popconfirm>
              <el-popconfirm :title="`确定审批拒绝${scope.row.memRealName}的积分申请吗？`" @confirm="rejectApply(scope.row)"
                icon="el-icon-delete" icon-color="skyblue">
                <span slot="reference" class="delete-btn">拒绝</span>
              </el-popconfirm>
              <span @click="updateRow(scope.row)" class="update-btn">修改</span>
              <el-popconfirm :title="`确定删除${scope.row.memRealName}吗？`" @confirm="deleteRow(scope.row)"
                icon="el-icon-delete" icon-color="skyblue">
              </el-popconfirm>
            </div>
            <div v-else>
              <span @click="updateRow(scope.row)" class="update-btn">修改</span>
              <el-popconfirm :title="`确定删除${scope.row.memRealName}吗？`" @confirm="deleteRow(scope.row)"
                icon="el-icon-delete" icon-color="skyblue">
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination :total="dataTotal" :page="searchInfo.page" :limit="searchInfo.limit" @pagination="onChangePages" />
      </div>
    </div>
    <!-- 放大图片的对话框 -->
    <el-dialog :visible.sync="dialogImg" width="50%" >
        <img :src="selectedImage" alt="放大图片" style="width: 100%;max-height: 70vh; overflow-y: auto;"  />
    </el-dialog>

    <!-- 新增弹框 -->
    <el-dialog :title="isUpdate ? '修改' : '新增'" :visible.sync="dialogVisible" top="5vh" width="672px">
      <el-form ref="form" class="dialog-form" :model="accountEdit" :rules="rules" label-width="110px">
        <el-form-item label="会员姓名" prop="memId">
          <el-select v-model="accountEdit.memId" placeholder="请输入会员姓名" :filter-method="queryMem" class="form-item-width" filterable>
            <el-option v-for="item in members" :key="item.id" :label="item.memRealName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="memTel">
          <el-input v-model="accountEdit.memTel" placeholder="请输入会员手机号"></el-input>
        </el-form-item>
        <el-form-item label="积分类型" prop="pointsType">
          <el-select v-model="accountEdit.pointsType" placeholder="请选择积分类型" class="form-item-width">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充电度数" prop="chargeDegree">
          <el-input v-model="accountEdit.chargeDegree" placeholder="请输入充电度数"></el-input>
        </el-form-item>
        <el-form-item label="积分数量" prop="pointsCount">
          <el-input v-model="accountEdit.pointsCount" placeholder="请输入积分数量"></el-input>
        </el-form-item>
        <el-form-item label="礼品名称" prop="awardName">
          <el-input v-model="accountEdit.awardName" placeholder="请输入礼品名称" ></el-input>
        </el-form-item>
        <el-form-item label="礼品价值" prop="awardCost">
          <el-input v-model="accountEdit.awardCost" placeholder="请输入礼品价值" ></el-input>
        </el-form-item>
        <!-- <el-form-item label="兑换凭证" prop="voucherPic">
            <img :src="baseURL + accountEdit.pointsPicture" style="width: 50px; height: 50px;" @click="handleImageClick(baseURL + accountEdit.pointsPicture)"/> 
            <img :src="accountEdit.pointsPicture" style="width: 50px; height: 50px;" @click="handleImageClick(accountEdit.pointsPicture)"/>
        </el-form-item> -->
        <el-form-item label="兑换凭证" prop="pointsPicture">
          <el-upload
            action="#" 
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSuccess"
            :multiple="false"
            ref="upload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogUpload">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="accountEdit.remark" placeholder="请备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmitDialog()">确定</el-button>
      </span>
      
      <!-- 放大图片的对话框 -->
      <el-dialog :visible.sync="dialogImg" width="50%">
        <img :src="selectedImage" alt="放大图片" style="width: 100%;" />
      </el-dialog>
    </el-dialog>

    <!-- 审核弹框 -->
    <!-- <el-dialog title="积分审核" :visible.sync="dialog" width="80%" @close="handleClose">
      <div style="margin-bottom: 20px;padding-left: 46px;">
        <el-form :inline="true" :model="searchApplyInfo" class="demo-form-inline">
          <el-form-item label="手机号">
            <el-input v-model="searchApplyInfo.memTel" placeholder="请输入会员手机号" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="onReview">查询</el-button>
            <el-button @click="onReviewReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="page-content margin-top"> -->
      <!-- 表格组件 -->
      <!-- <el-table :data="tableApplyData" stripe style="width: 100%"  border
        :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
        :cell-style="{'text-align':'center'}"
      >
        <el-table-column label="会员姓名" prop='memRealName'></el-table-column>
        <el-table-column label="手机号" prop='memTel' width="120px"></el-table-column>
        <el-table-column label="车牌号" prop='carNo'></el-table-column>
        <el-table-column label="积分类型" prop='pointsType'>
          <template slot-scope="scope">
            <span v-if="scope.row.pointsType === 1">充电</span>
            <span v-else-if="scope.row.pointsType === 2">评论</span>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" prop='chargeDegree'></el-table-column>
        <el-table-column label="积分数量" prop='pointsCount'></el-table-column>
        <el-table-column label="完成时间" prop='createTime' width="170px"></el-table-column>
        <el-table-column label="图片凭证" prop='pointsPicture'>
          <template slot-scope="scope">
            <img :src="baseURL + scope.row.pointsPicture" style="width: 50px; height: 50px;" @click="handleImageClick(baseURL + scope.row.pointsPicture)"/>
          </template>
          
        </el-table-column>
        
        <el-table-column label="审核状态" prop='status'>
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: rgb(238, 145, 6)">待审核</span>
            <span v-else-if="scope.row.status === 1" style="color: #008000">已审核</span>
            <span v-else-if="scope.row.status === 2" style="color: red">已拒绝</span>
          </template>
        </el-table-column> -->

        <!-- 操作 -->
        <!-- <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-popconfirm :title="`确定审批通过${scope.row.memRealName}的积分申请吗？`" @confirm="passApply(scope.row)"
              icon="el-icon-delete" icon-color="skyblue">
              <span slot="reference" class="update-btn">通过</span>
            </el-popconfirm>
            <el-popconfirm :title="`确定审批拒绝${scope.row.memRealName}的积分申请吗？`" @confirm="rejectApply(scope.row)"
              icon="el-icon-delete" icon-color="skyblue">
              <span slot="reference" class="delete-btn">拒绝</span>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table> -->
      <!-- 分页组件 -->
      <!-- <div>
        <Pagination :total="dataApplyTotal" :page="searchApplyInfo.page" :limit="searchApplyInfo.limit" @pagination="onChangeApplyPages" />
      </div>
    </div> -->
      <!-- 放大图片的对话框 -->
      <!-- <el-dialog :visible.sync="dialogImg" width="50%" >
        <img :src="selectedImage" alt="放大图片" style="width: 100%;max-height: 70vh; overflow-y: auto;"  />
      </el-dialog>

    </el-dialog> -->

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {savePoints, getPoints, deletePoints, getMember,rejectApply,passApply } from '@/api/member.js'
import API from '../../utils/baseurl'
import { uploadImage,initOSSClient,deleteImage} from '../../api/uploadFile'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      baseURL:API.fayongApi,
      // 查询积分列表数据
      searchInfo: {
        memRealName: '',
        pointsType:'',
        carNo:'',
        page: 1,
        size: 20,
      },
      // 查询待审核列表数据
      searchApplyInfo: {
        memRealName: '',
        memTel: '',
        page: 1,
        size: 20,
      },
      // 弹框表单信息
      accountEdit: {
        memId: '',
        memTel: '',
        pointsType: '',
        chargeDegree: '',
        pointsCount: '',
        awardName: '',
        awardCost: '',
        pointsPicture: '',
        remark: '',
      },
      searchOptions: [{
          value: 1,
          label: '充电'
        }, {
          value: 5,
          label: '核销'
        }
      ],
      options: [{
          value: 1,
          label: '充电'
        }, {
          value: 2,
          label: '评论'
        }, {
          value: 5,
          label: '核销'
        }
      ],
      //会员姓名
      members:[],
      // 表格数据
      tableData: [],
      // 数据总数
      dataTotal: 100,
      // 表格数据
      tableApplyData: [],
      // 数据总数
      dataApplyTotal: 100,
      // 标记是否新增
      isUpdate: false,
      // 是否展示弹框
      dialogVisible: false,
      // dialog:false,
      dialogImg: false, // 控制对话框显示
      selectedImage: '' ,// 当前选中的图片

      fileList: [],
      dialogImageUrl:'',
      dialogUpload:false,
      
      // 表格标题数组
      // tableTitle: [
      //   { name: '会员姓名', code: 'memRealName', width: '' },
      //   { name: '手机号', code: 'memTel', width: '' },
      //   { name: '积分类型', code: 'pointsType', prop: 'pointsType', width: '',
      //     formatter:(value)=>{
      //       if(value == 1){
      //         return '充电';
      //       }else if(value == 2){
      //         return '评论';
      //       }else if(value == 5){
      //         return '核销';
      //       }else{
      //         return ''
      //       }
      //     }  },  
      //   { name: '充电度数', code: 'chargeDegree', width: '130px' }, 
      //   { name: '积分数量', code: 'pointsCount', width: '130px' }, 
      //   { name: '完成时间', code: 'createTime', width: '170px' },
      //   { name: '审核状态', code: 'status', prop: 'status', width: '130px',
      //     formatter:(value)=>{
      //       if(value == 0){
      //         return '待审核';
      //       }else if(value == 1){
      //         return '已审核';
      //       }else if(value == 2){
      //         return '已拒绝';
      //       }else{
      //         return ''
      //       }
      //     } 
      //   },        
      //   { name: '备注', code: 'remark', width: '' },
      // ],
      //表单校验规则对象
      rules: {
        memId: [
          { required: true, message: '请选择会员', trigger: 'blur' }
        ],
        memTel: [
          { required: true, message: '请输入会员手机号', trigger: 'blur' }
        ],
        pointsType: [
          { required: true, message: '请选择积分类型', trigger: 'blur' }
        ],
        pointsCount: [
          { required: true, message: '请输入积分数量', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
    // 获取列表数据
    this.onSearch()
  },

  methods: {
    // 查询按钮
    onSearch() {
      this.searchInfo.page = 1
      this.onGetDataList()
    },
    // 获取列表
    async onGetDataList() {
      // 积分接口
      const data = await getPoints(this.searchInfo)
      this.tableData = data.data.records
      this.dataTotal = data.data.total
    },
    // 重置按钮
    onReset() {
      this.searchInfo.memRealName = '',
      this.searchInfo.memTel = '',
      this.searchInfo.pointsType = '',
      this.searchInfo.carNo = '',
      this.onSearch()
    },
    async queryMem(key){
      if(key){
        console.info(key)
        const memberData = await getMember({memTel:key})
        this.members = memberData.data.records
      }else{
        const memberData = await getMember({})
        this.members = memberData.data.records
      }
    },
    // 新增按钮
    async onAddUser() {
      this.queryMem()
      this.isUpdate = false
      this.dialogVisible = true
      this.accountEdit = {
        id:0,
        memId: '',
        memTel:'',
        pointsType:'',
        chargeDegree:'',
        pointsCount:'',
        awardName:'',
        awardCost:'',
        remark:'',
      } 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
    },

    // 审核按钮
    // async onReview() {
    //   //展示模态框
    //   this.dialog = true
    //   // 获取待审核数据列表
    //   const applyInfo = {};
    //   applyInfo.status = 0;
    //   applyInfo.memTel = this.searchApplyInfo.memTel;
    //   applyInfo.page = this.searchApplyInfo.page;
    //   applyInfo.size = this.searchApplyInfo.size;
    //   const data = await getPointsApply(applyInfo)
    //   this.tableApplyData = data.data.records
    //   this.dataApplyTotal = data.data.total
    // },
    async handleRemove() {
      console.log(this.accountEdit.awardSourcePic)
      //this.consume.imageUrl = '' // 清空图片URL
      const a = await deleteImage(this.accountEdit.awardSourcePic);
      console.log(a)
      this.accountEdit.pointsSourcePicture = '';
      this.accountEdit.pointsPicture = '';
      this.fileList =[];
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogUpload = true;
    },
    handleFileChange(e) {
      this.file = e.target.files[0]
    },
   
    async uploadSuccess(file) {
      try {
        // const result = await this.client.put(fileName, file.file)
        const url =await uploadImage(file.file);
        this.accountEdit.pointsPicture = url
        this.msgsuccess('上传成功')
      } catch (err) {
        this.msgsuccess('上传失败')
      }
    },
    // 审核查询信息重置按钮
    // onReviewReset() {
    //   this.searchApplyInfo.memTel = ''
    //   this.onReview()
    // },

    // 修改按钮
    async updateRow(row) {
      this.queryMem()
      this.isUpdate = true
      this.dialogVisible = true 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
      Object.assign(this.accountEdit, row)
      const client = await initOSSClient();
      const url = client.signatureUrl(row.pointsPicture);
      this.fileList=[{
        name: 'preview-image',
        url: url
      }];
    },
    // 删除按钮
    async deleteRow(row) {
      const data = await deletePoints(row.id)
      if (data.code == '200') {
        this.msgsuccess('删除成功')
        this.onGetDataList()
      } else {
        this.msgerror('删除失败')
      }

    },
    async rejectApply(row){
      const rejectInfo = {};
      rejectInfo.status = 2;
      rejectInfo.id = row.id;
      const data = await rejectApply(rejectInfo)
      if (data.code == '200') {
        this.msgsuccess('审核拒绝成功！')
        this.onSearch()
      } else {
        this.msgerror('审核失败')
      }
    },
    async passApply(row){
      const passInfo = {};
      passInfo.status = 1;
      passInfo.id = row.id;
      const data = await passApply(passInfo)
      if (data.code == '200') {
        this.msgsuccess('审核通过成功！')
        // this.onReview()
        this.onSearch()
      } else {
        this.msgerror('审核失败')
      }
    },
    // 积分列表分页方法
    onChangePages(pageInfos) {
      const { page, limit } = pageInfos
      this.searchInfo.page = page
      this.searchInfo.size = limit
      this.onGetDataList()
    },
    // 积分待审核列表分页方法
    onChangeApplyPages(pageInfo) {
      const { page, limit } = pageInfo
      this.searchApplyInfo.page = page
      this.searchApplyInfo.size = limit
      this.onReview()
    },

    // 弹框确认按钮
    onSubmitDialog() {
      //先进行表单验证，验证通过后再发请求
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await savePoints(this.accountEdit)
          if (data.code == '200') {
            this.dialogVisible = false
            this.msgsuccess('保存成功')
            this.onGetDataList()
          } else {
            this.dialogVisible = false
            this.msgerror('保存失败')
          }
        } else {
          return false;
        }
      })
    },
    handleClose(){
      this.onGetDataList();
    },
    getColumnColor(val,propStr){
      if(propStr == "status"){
        if(val == 0){
          return 'rgb(238, 145, 6)';
        }else if (val ==1){
          return '#008000';
        }else if (val ==2){
          return 'red';
        }
      }
    },
    
   // 点击图片时触发
   handleImageClick(imageUrl) {
    console.log(imageUrl);
      this.selectedImage = imageUrl; // 设置选中的图片
      this.dialogImg = true; // 显示对话框
    }
  
  },
}
</script>

<style lang="less" scoped>
.form-item-width {
  width: 100%;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.el-form-item {
  font-weight: bold;
  margin: 0 20px 4px 10px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.examine-btn {
  cursor: pointer;
  color: #409eff;
}

.update-btn {
  cursor: pointer;
  color: #409eff;
}

.pass-btn {
  cursor: pointer;
  color: #008000;
}

.delete-btn {
  cursor: pointer;
  color: #f56c6c;
  margin: 0px 20px;
}

.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>